export const ErrorType = Object.freeze({
  NETWORK: "NETWORK",
  AUTH: "AUTH",
  FORBIDDEN: "FORBIDDEN",
  NOT_FOUND: "NOT_FOUND",
  VALIDATION: "VALIDATION",
  SERVER: "SERVER",
  UNKNOWN: "UNKNOWN",
});

export const getErrorMessage = (error) => {
  if (error == null) return "";
  if (typeof error === "string") return error;
  if (error.response && error.response.data && error.response.data.message)
    return error.response.data.message;
  if (error.data && error.data.message) return error.data.message;
  if (error.error) return error.error;
  if (error.description) return error.description;
  if (error.message) return error.message;
  if (error.errors && typeof error.errors === "string") return error.errors;
  if (error.errors && typeof Array.isArray(error.errors))
    return error.errors.join(" ");
  console.log(`getErrorMessage: ${error} error format unknown`);
  return Object.entries(error).reduce((str, [p, val]) => {
    return `${str}${p}::${val}\n`;
  }, "");
};

const getStatusCode = (error) => {
  if (error == null || typeof error !== "object") return null;
  const raw = error.status ?? error.originalStatus ?? error.response?.status;
  if (raw == null) return null;
  const n = Number(raw);
  return Number.isFinite(n) ? n : null;
};

const classifyByStatus = (status) => {
  if (status === 401) return ErrorType.AUTH;
  if (status === 403) return ErrorType.FORBIDDEN;
  if (status === 404) return ErrorType.NOT_FOUND;
  if (status === 400 || status === 422) return ErrorType.VALIDATION;
  if (status >= 500) return ErrorType.SERVER;
  return ErrorType.UNKNOWN;
};

export const classifyError = (error) => {
  const message = getErrorMessage(error);
  const statusCode = getStatusCode(error);

  let type;
  if (statusCode != null) {
    type = classifyByStatus(statusCode);
  } else if (
    error?.status === "FETCH_ERROR" ||
    error?.name === "NetworkError" ||
    error?.message === "Network Error"
  ) {
    type = ErrorType.NETWORK;
  } else {
    type = ErrorType.UNKNOWN;
  }

  return { message, type, statusCode };
};

export const isNotFoundError = (error) => {
  if (
    error?.status === 500 ||
    error?.status === 400 ||
    getErrorMessage(error).includes("role checking was not performed")
  )
    return true;
  return false;
};
